define((require) => {
    "use strict";

    const ActionPropertiesView          = require("ui/experience/action/ActionPropertiesView");
    const AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView");
    const CharacterPropertiesView       = require("ui/experience/widgets/CharacterPropertiesView");
    const ImprovedView                  = require("editor/zbone/ImprovedView");
    const SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const template                      = require("ui/experience/widgets/textEnhancedWidget/TextWidgetPropertiesView.tpl");

    /**
     * The properties view for a text widget.
     *
     * @class TextEnhancedWidgetPropertiesView
     * @constructor
     *
     * @cfg {TextWidgetModel} model The model for the text widget being edited.
     */
    return ImprovedView.extend({

        template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            actionProperties: ".action-properties"
        },

        onRender() {
            this.__super();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                showWidthControls: true,
                hideSizeControls: true,
                widgetView: this.options.widgetView
            }));
            this.analyticsProperties.show(this._setAnalyticsLabel({model: this.model}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this.actionProperties.show(new ActionPropertiesView({model: this.model}));
        }
    }, {
        EXPAND_PROPERTY: CharacterPropertiesView.EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/textEnhancedWidget/TextWidgetPropertiesView.js